module.exports = __webpack_public_path__ + "img/mecha-12.1ee3e5ef.jpg";